'use strict';

const { Component } = require('phy');

const { getOfferImageSize, getLogoImageSize } = require('./slide');

class CarouselBase extends Component {
  getPagesItems(items, selectedIndex) {
    const limit = 4;
    if (selectedIndex + limit > items.length) {
      return [
        ...items.slice(selectedIndex),
        ...items.slice(0, selectedIndex - items.length + limit),
      ];
    }

    return items.slice(selectedIndex, selectedIndex + limit);
  }

  windowResize() {
    const { innerWidth } = this.state;
    const { innerWidth: windowInnerWidth } = window;

    if (innerWidth === windowInnerWidth) {
      return;
    }

    this.setState({
      innerWidth: windowInnerWidth,
    });
  }

  clickNavigation(event, index) {
    event.preventDefault();
    this.changeSlide(index);
  }

  changeSlide(index = true) {
    const { slidesCount } = this;
    const { selectedIndex, pageNumber } = this.state;
    let newIndex = null,
      newPageNumber = null;

    const values = {
      NEXT: true,
      PREV: false,
    };

    if (index === values.NEXT) {
      newIndex = selectedIndex >= slidesCount - 1 ? 0 : selectedIndex + 1;
      newPageNumber = pageNumber + 1;
    } else if (index === values.PREV) {
      newIndex = selectedIndex === 0 ? slidesCount - 1 : selectedIndex - 1;
      newPageNumber = pageNumber - 1;
    } else if (index > 0) {
      newIndex =
        selectedIndex + index > slidesCount - 1 ? 0 : selectedIndex + index;
      newPageNumber = pageNumber + 1;
    }

    if (newIndex !== null && newPageNumber !== null) {
      this.setState({
        selectedIndex: newIndex,
        pageNumber: newPageNumber,
      });
    }
  }

  mouseEnterHandler() {
    clearInterval(this.carouselInterval);
  }

  mouseLeaveHandler() {
    this.autoPlay();
  }

  autoPlay() {
    const { duration } = this;

    if (parseInt(duration)) {
      this.carouselInterval = setInterval(this.changeSlide, duration);
    }
  }

  preloadImages() {
    const { items, isTouch } = this.props;
    const { innerWidth } = this.state;

    const sizes = [
      getOfferImageSize(isTouch, innerWidth),
      getLogoImageSize(isTouch),
    ];

    sizes.forEach(size => {
      items.slice(1).forEach(item => {
        const src = getMediaSrc(item.media, size);
        if (src) {
          // eslint-disable-next-line no-undef
          const img = new Image();
          img.src = src;
        }
      });
    });
  }
}

function getMediaSrc(data, size) {
  const media = data && data[0];

  return media && media.mediaUrl
    ? media.mediaUrl.replace('{{options}}', `${size[0]},`)
    : '';
}

module.exports = CarouselBase;
